import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children"];
import PropTypes from 'prop-types';
import React from 'react';
import { withIcon } from '../Icon';
var innerSvg = '<path d="M28 7H15.46l-1.7-2.55a1 1 0 00-.83-.45H4a2 2 0 00-2 2v19a2 2 0 002 2h24a2 2 0 002-2V9a2 2 0 00-2-2zM16 23a6 6 0 01-3.59-1.2 5.78 5.78 0 01-1.21-1.21 6 6 0 018.39-8.39 5.78 5.78 0 011.21 1.21A6 6 0 0116 23z"/><path d="M13.64 20.57a4.28 4.28 0 005.93-5.93zM16 12.71a4.28 4.28 0 00-3.57 6.65l5.93-5.93a4.27 4.27 0 00-2.36-.72z"/>';
export var SpamFolderSVG = function SpamFolderSVG(_ref) {
  var children = _ref.children,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    dangerouslySetInnerHTML: {
      __html: innerSvg
    }
  }));
};
SpamFolderSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node
} : {};
export default withIcon(SpamFolderSVG);